<template>
  <div class="banner_rotativo">
    <loading v-if="! showContent"></loading>

    <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="showContent && existeSliders">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#myCarousel" :data-slide-to="index" :class="index == 0 ? 'active' : ''"
            v-for="(slider, index) in items"></li>
      </ol>

      <!-- Wrapper for slides -->
      <div class="carousel-inner">
        <div :class="index == 0 ? 'item active' : 'item'" v-for="(slider, index) in items">
          <a v-if="slider.sliderLink" :href="retornaLink(slider)" :target="isBlank(slider)">
            <img :src="slider.sliderImage"   :alt="slider.sliderName" style="width:100%;">
          </a>
          <img v-if="!slider.sliderLink" :src="slider.sliderImage"   :alt="slider.sliderName" style="width:100%;">
        </div>
      </div>

      <!-- Left and right controls -->
      <a class="left carousel-control" href="#myCarousel" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#myCarousel" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Slides',
        showContent: true,
        items: [],
      }
    },
    methods:{
      retornaLink(item){
        if(item){
          return item.sliderLink;
        }
        return '';
      },
      isBlank(slider){
        if(!slider.sliderTarget){
          return "_self";
        }
        return "_blank";
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      // get('content/' + this.bloco.id).then(function (response) {
        self.showContent = true;
        self.items = this.$store.getters['getSiteContent'].result.data.slider;
        // self.items = window.siteconfig.result.data.slider;
      // });
    },
    mounted(){
      $('.carousel').carousel()
    },
    computed:{
      existeSliders(){
        if(this.items.length > 0){
          return true;
        }
        return false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Slides.vue